import React from 'react';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { SearchResult } from 'wanderu-component-search-result';
import { WDSButton } from 'wanderu-components';

import styles from './TripItem.scss';

const propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    href: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    position: PropTypes.number.isRequired,
    trip: PropTypes.object.isRequired,
};

function TripItem(props) {
    const {
        history,
        href,
        locale,
        onClick,
        position,
        trip,
    } = props;

    function handleClick() {
        onClick(position);

        history.push({
            pathname: `/${locale}${href}`,
        });
    }

    return (
        <WDSButton
            className={styles.container}
            onClick={handleClick}
            variant="unstyled"
        >
            <SearchResult
                {...trip}
                className={styles.searchResult}
                variant="timeTable"
            />
        </WDSButton>
    );
}

TripItem.propTypes = propTypes;

export { TripItem };
export default withRouter(TripItem);
